/** Banner central transitório (região entrada, caminho aberto, interrupt, boss derrotado). */
export type BannerKind = "info" | "danger" | "boss";

export class Banner {
  private current: HTMLDivElement | null = null;
  private timer = 0;

  constructor(private readonly uiRoot: HTMLElement) {}

  show(text: string, kind: BannerKind = "info", durationMs = 2200): void {
    // um banner por vez: o mais recente substitui o anterior (sem sobreposição/poluição)
    if (this.current) {
      this.current.remove();
      window.clearTimeout(this.timer);
    }
    const el = document.createElement("div");
    el.className = `banner banner-${kind}`;
    el.textContent = text;
    this.uiRoot.appendChild(el);
    this.current = el;
    this.timer = window.setTimeout(() => {
      el.remove();
      if (this.current === el) this.current = null;
    }, durationMs);
  }
}
